export default __webpack_public_path__ + "static/media/linkedInIcon.f2f7f8ac.svg";